import { Spinner } from '@ui/components/loaders'
import { useDemoNavigation } from '@ui/lib/hooks/useDemoNavigation'
import { useHasStack } from '@ui/lib/hooks/useHasStack'
import { AvailabilitySuccess, NoAvailability } from '@ui/pages/setupAccount/components/index'

export const SetupAccount = () => {
  const handleDemoNavigation = useDemoNavigation()

  const { loading, hasStack } = useHasStack()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return hasStack ? (
    <AvailabilitySuccess onTryDemo={handleDemoNavigation} />
  ) : (
    <NoAvailability onTryDemo={handleDemoNavigation} />
  )
}
